// 与后端 BaseDataUpdateModule 保持一致。来源由当前操作入口指定，不能沿用详情中的旧值。
export const BaseDataUpdateModule = Object.freeze({
  BASE_DATA: 'BASE_DATA',
  DATA_EXCEPTION: 'DATA_EXCEPTION',
  SHIP_TIMELINE: 'SHIP_TIMELINE'
})
